import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { Dropdown, Alert, Button } from '../../../UI/Common';
import Datagrid from '../../../UI/Datagrid';
import { validationSchema } from './validation';
import { Form } from 'reactstrap';
import { DialogBox } from '../../../UI/Modal';
import helper from '../../../../utils/helper';
import { useHistory } from 'react-router';
import ReactSelect from '../../../UI/ReactSelect';

const MKTMonitorsPage = (props) => {
  const history = useHistory();
  //prettier-ignore
  const { t, errors, openModal, isFetching, departments, mktMonitors, datagridProps } = props;
  const [form, setForm] = React.useState({
    deptId: undefined,
  });
  React.useEffect(() => {
    const { deptId } = helper.getUserDepartment(departments);
    setForm({ deptId });
  }, [departments.length]);
  const onChangeDept = (value, setFieldTouched, setFieldValue) => {
    setFieldValue('deptId', value);
    setForm({ deptId: value });
  };
  React.useEffect(() => {
    if (form.deptId !== undefined) {
      props.onChangeDept(form.deptId);
    }
  }, [form.deptId]);
  const onNew = (deptId) => {
    history.push(`/reports/mkt-monitors/new-mkt-monitor/${deptId}`);
  };
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={errors} />
        <DialogBox
          isOpen={openModal}
          title={t('Delete MKT monitor')}
          body={t('Are you sure you want to delete this MKT monitor?')}
          yesBtnLabel={t('Delete')}
          onYes={() => props.onDeleteMktMonitor()}
          noBtnLabel={t('Cancel')}
          onNo={() => props.onCancel()}
        />
        <Formik
          enableReinitialize
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => onNew(values.deptId)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            setFieldValue,
            touched,
            isValid,
            handleSubmit,
          }) => {
            return (
              <>
                <Form>
                  <ReactSelect
                    required
                    containerStyle={{ width: '30%' }}
                    isClearable={false}
                    label="Department"
                    options={departments}
                    value={values.deptId}
                    onChange={({ value }) =>
                      onChangeDept(value, setFieldTouched, setFieldValue)
                    }
                    valueKey="id"
                    labelKey="name"
                    invalid={touched.deptId}
                    error={errors.deptId}
                  />
                  <Button
                    id="new-mkt-monitor-btn"
                    classes="mb-10"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    <i className="md-icon">add</i>
                    {t('New MKT Monitor')}
                  </Button>
                </Form>
                <Datagrid
                  datagridProps={{
                    keyField: 'id',
                    data: mktMonitors.filter(
                      (record) => record.departmentId === values.deptId,
                    ),
                    loading: isFetching,
                    ...datagridProps,
                  }}
                  ctxMenuOptions={props.ctxMenuOptions}
                  exportProps={{
                    fileName: 'MKTMonitors',
                  }}
                />
              </>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(MKTMonitorsPage);
